import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbModel } from 'src/app/models/common/breadcrumb.module';
import { BreadcrumbService } from 'src/app/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-new-breadcrumb',
  templateUrl: './new-breadcrumb.component.html',
  styleUrls: ['./new-breadcrumb.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class NewBreadcrumb implements OnInit {
  breadcrumbs: BreadcrumbModel[] = [];

  constructor(private breadcrumbService: BreadcrumbService) { }

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe(bc => {
      this.breadcrumbs = bc;
    });
  }
}